var textboxWebStyle = {
    container: {
        position: 'relative',
        width: '100%'
    },
    input: {
        base: {
            fontFamily: "'Rubik', 'Helvetica', 'Arial'",
            fontWeight: 400,
            backgroundColor: 'rgb(255,255,255)',
            border: '1px solid rgb(154, 159, 166)',
            lineHeight: '1.25',
            color: 'rgb(26,32,38)',
            boxSizing: 'border-box',
            display: 'block',
            width: '100%',
            margin: 0,
            padding: '0.25rem 1rem',
            textAlign: 'left',
            fontStyle: 'normal',
            verticalAlign: 'middle',
            letterSpacing: 'normal',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            boxShadow: '0 0 0 0 transparent',
            borderRadius: '6px',
            '&::placeholder': {
                opacity: 1,
                color: 'rgb(154, 159, 166)'
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:focus': {
                outline: 'none',
                boxShadow: '0 0 0 2px rgb(66,145,233)'
            },
            '&:disabled': {
                borderColor: 'rgb(217,220,222)',
                color: 'rgb(154, 159, 166)',
                pointerEvents: 'none'
            }
        },
        disabled: {
            borderColor: 'rgb(217,220,222)',
            color: 'rgb(154, 159, 166)',
            pointerEvents: 'none'
        },
        size: {
            s: {
                fontSize: '0.875rem',
                height: 36,
                padding: '0.25rem 0.75rem'
            },
            m: {
                fontSize: '1rem',
                height: 40
            }
        },
        hasError: {
            borderColor: 'rgb(219,44,0)',
            '&:focus': {
                outline: 'none',
                boxShadow: '0 0 0 2px rgb(232,102,69)'
            }
        },
        isRtl: {
            textAlign: 'right',
            paddingRight: '1rem'
        },
        iconLeft: {
            paddingLeft: '2.5rem'
        },
        iconRight: {
            paddingRight: '2.5rem'
        }
    },
    iconContainer: {
        base: {
            height: '1rem',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'block'
        },
        iconLeft: {
            left: '1rem'
        },
        iconRight: {
            right: '1rem'
        }
    },
    icon: {
        color: 'rgb(105,113,122)'
    }
};
export default textboxWebStyle;
